import { frontendURL } from '../../../../helper/URLHelper';
import {
  CUSTOM_ATTRIBUTE_MANAGE_PERMISSIONS,
  CUSTOM_ATTRIBUTE_CREATE_PERMISSIONS,
  CUSTOM_ATTRIBUTE_EDIT_PERMISSIONS,
  CUSTOM_ATTRIBUTE_DELETE_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
const SettingsWrapper = () => import('../SettingsWrapper.vue');
const AttributesHome = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/custom-attributes'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: 'list',
        },
        {
          path: 'list',
          name: 'attributes_list',
          component: AttributesHome,
          meta: {
            permissions: [
              'administrator',
              CUSTOM_ATTRIBUTE_MANAGE_PERMISSIONS,
              CUSTOM_ATTRIBUTE_CREATE_PERMISSIONS,
              CUSTOM_ATTRIBUTE_EDIT_PERMISSIONS,
              CUSTOM_ATTRIBUTE_DELETE_PERMISSIONS,
            ],
          },
        },
      ],
    },
  ],
};
